import { LineWiseGarmentsModel } from "./line-wise-garments.model";

export class DayLineWiseCompletedGarmentsModel {
    date: string;
    lineWiseGmtInfo: LineWiseGarmentsModel[];

    constructor(date: string, lineWiseGmtInfo: LineWiseGarmentsModel[]) {
        this.date = date;
        this.lineWiseGmtInfo = lineWiseGmtInfo;
    }
}